import { render, staticRenderFns } from "./ConsultantDetails.vue?vue&type=template&id=93e28a92&scoped=true"
import script from "./ConsultantDetails.vue?vue&type=script&lang=js"
export * from "./ConsultantDetails.vue?vue&type=script&lang=js"
import style0 from "./ConsultantDetails.vue?vue&type=style&index=0&id=93e28a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e28a92",
  null
  
)

export default component.exports